import { GlobalDocumentIds } from '../../../types/GlobalDocumentIds';
import { GlobalMenuState } from '../../../contexts/GlobalMenuStore';
import { Breakpoints } from '../../../types/Breakpoints';

export const getMenuIdentifierById = (id: string): GlobalMenuState => {
  switch (id) {
    case GlobalDocumentIds.mainNavigationBox:
      return GlobalMenuState.MAIN_NAVIGATION;
    case GlobalDocumentIds.personalBox:
      return GlobalMenuState.PAL;
    case GlobalDocumentIds.instantSearch:
      return GlobalMenuState.INSTANT_SEARCH;
    default:
      return GlobalMenuState.NONE;
  }
};

export const getBreakpointThreshold = (id: string): number => {
  switch (id) {
    case GlobalDocumentIds.mainNavigationBox:
      return Breakpoints.l_screen;
    case GlobalDocumentIds.personalBox:
      return Breakpoints.xl_screen;
    case GlobalDocumentIds.instantSearch:
    default:
      return Breakpoints.m_smartphone_landscape;
  }
};
